import React from "react";
import { styled } from "@mui/system";
import MUIMenu from "@mui/material/Menu";
import { MenuProps as MenuPropsMUI } from "@mui/material/Menu";
export interface MenuProps extends MenuPropsMUI {}

const MenuRoot = styled(MUIMenu, {
  name: "Menu",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) =>
  theme.name === "fic"
    ? {
        "& .MuiMenu-paper": {
          borderRadius: 4,
          // boxShadow: "0px 10px 20px 0px #15293526",
          "& .MuiList-root": {
            paddingTop: 0,
            paddingBottom: 0,
            borderRadius: 4
          }
        }
      }
    : {
        "& .MuiMenu-paper .MuiList-root": {
          paddingTop: 0,
          paddingBottom: 0
        }
      }
);

export const Menu = React.forwardRef<HTMLDivElement, MenuProps>(function Menu(
  props,
  ref
) {
  return <MenuRoot {...props} ref={ref} />;
}) as React.FC<MenuProps>;
